/* tt-contact.js - the Contact page's message form, drawn by the theme, filed by
   the Hub.

   A port of the Hub's own page script (routes/contact.tsx), step for step, so
   the two cannot disagree about what a shopper is asked: one sentence first,
   which the Hub sorts ("triage"); then either the claims door or the details;
   then "submit", which files the ticket and returns its reference. The Hub
   allows both storefront origins to post, so no frame and no email.

   The Hub decides where a claim goes (it returns claimsUrl, empty on a store
   whose claims are filed here), so this file holds no store knowledge. */
(function () {
  'use strict';

  function init(root) {
    var api = root.getAttribute('data-api');
    var q = function (sel) { return root.querySelector(sel); };
    var step = function (name) { return q('[data-step="' + name + '"]'); };
    var show = function (el, on) { if (el) el.hidden = !on; };
    var msg = '';
    var kind = '';
    var claimsUrl = '';

    function post(payload) {
      return fetch(api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).then(function (r) {
        return r.json().then(function (j) { return { status: r.status, body: j }; });
      });
    }

    function fail(el, text) { el.textContent = text; show(el, true); }

    function busy(btn, on, label) {
      btn.disabled = on;
      btn.textContent = label;
    }

    /* Choice cards are built from the theme's own pieces: a ruled panel, the
       display face for the title, an ink button or a text link. */
    function card(title, text, actionHtml) {
      return '<div class="tt-contact__choice"><h4 class="tt-contact__choice-title">' + title + '</h4>' +
        '<p class="tt-contact__choice-text">' + text + '</p>' + actionHtml + '</div>';
    }

    function claimCard(lead) {
      if (!claimsUrl) return '';
      return card('Something is damaged or faulty',
        (lead ? lead + ' ' : '') + 'The claim form asks for your order and a photo so we can send a replacement part without going back and forth.',
        '<a class="tt-contact__btn" href="' + claimsUrl + '">Start a claim</a>');
    }

    function questionCard(lead, label) {
      return card('Everything else', lead,
        '<button type="button" class="tt-contact__btn tt-contact__btn--ghost" data-pick>' + label + '</button>');
    }

    function openFields(title, sub) {
      q('[data-h2]').textContent = title;
      q('[data-sub2]').textContent = sub;
      show(q('[data-choices]'), false);
      show(q('[data-fields]'), true);
    }

    function render() {
      show(step('1'), false);
      show(step('2'), true);
      var c = q('[data-choices]');
      show(c, true);
      show(q('[data-fields]'), false);
      show(q('[data-mso-fields]'), false);
      if (kind === 'CLAIM' && claimsUrl) {
        q('[data-h2]').textContent = 'That sounds like a claim';
        q('[data-sub2]').textContent = 'Claims go through their own form so we can get a part out to you.';
        c.innerHTML = claimCard('') + questionCard('Not what you meant? Send it to us as a question instead.', 'Ask a question instead');
      } else if (kind === 'ASK') {
        q('[data-h2]').textContent = 'Which is closer?';
        q('[data-sub2]').textContent = 'We could not tell from that, and we would rather ask than send you the wrong way.';
        c.innerHTML = claimCard('Pick this if something you own arrived damaged or has failed.') +
          questionCard('Orders, delivery, sizing, returns, dealers, or anything else.', 'Ask a question');
      } else {
        c.innerHTML = '';
        openFields('Send us the details', 'We will reply by email.');
      }
      var pick = q('[data-pick]');
      if (pick) {
        pick.addEventListener('click', function () {
          openFields('Send us the details', 'We will reply by email.');
          q('#ttc-name').focus();
        });
      }
    }

    q('[data-go]').addEventListener('click', function () {
      var go = this;
      msg = q('#ttc-what').value.trim();
      show(q('[data-err1]'), false);
      if (msg.length < 5) return fail(q('[data-err1]'), 'Please write a sentence or two.');
      busy(go, true, 'One moment…');
      post({ intent: 'triage', message: msg }).then(function (res) {
        busy(go, false, 'Continue');
        if (!res.body || !res.body.ok) {
          return fail(q('[data-err1]'), (res.body && res.body.error) || 'Something went wrong. Please try again.');
        }
        kind = res.body.kind;
        claimsUrl = res.body.claimsUrl || '';
        render();
      }).catch(function () {
        busy(go, false, 'Continue');
        /* The network died, not the classifier: offer both doors. */
        kind = 'ASK';
        render();
      });
    });

    q('[data-back]').addEventListener('click', function () {
      show(step('2'), false);
      show(q('[data-err2]'), false);
      show(step('1'), true);
    });

    var mso = q('[data-mso]');
    if (mso) {
      mso.addEventListener('click', function (e) {
        e.preventDefault();
        kind = 'MSO_REQUEST';
        msg = '';
        show(step('1'), false);
        show(step('2'), true);
        show(q('[data-mso-fields]'), true);
        openFields('Request an MSO', 'We will email the document back. The hull number is what we stamp on it, so it has to be right.');
        q('#ttc-hin').focus();
      });
    }

    q('[data-send]').addEventListener('click', function () {
      var send = this;
      var err = q('[data-err2]');
      show(err, false);
      var email = q('#ttc-email').value.trim();
      if (!email) return fail(err, 'We need an email to reply to.');
      if (kind === 'MSO_REQUEST' && q('#ttc-hin').value.trim().length < 6) {
        return fail(err, 'We need the hull number to issue an MSO. It is on the stern.');
      }
      busy(send, true, 'Sending…');
      post({
        intent: 'submit', message: msg, kind: kind,
        name: q('#ttc-name').value, email: email,
        order: q('#ttc-order').value, company: q('#ttc-company').value,
        hin: q('#ttc-hin').value, boat: q('#ttc-boat').value,
      }).then(function (res) {
        busy(send, false, 'Send');
        if (!res.body || !res.body.ok) {
          return fail(err, (res.body && res.body.error) || 'Something went wrong. Please try again.');
        }
        show(step('2'), false);
        show(step('done'), true);
        q('[data-done]').textContent = res.body.ref
          ? 'Your reference is ' + res.body.ref + '. We will reply to ' + email + '.'
          : 'We will reply to ' + email + '.';
      }).catch(function () {
        busy(send, false, 'Send');
        fail(err, 'Could not reach us just then. Please try again.');
      });
    });
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* "Write a message" glides to the form and puts the cursor in it (Josh, 2026-10-16). Any
     in-page link in the routes row does the same for its own target. */
  function glide() {
    document.querySelectorAll('.tt-contact__routes a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', a.getAttribute('href'));
        var field = target.querySelector('textarea, input');
        if (field) setTimeout(function () { field.focus({ preventScroll: true }); }, reduce ? 0 : 600);
      });
    });
  }

  /* The questions open and close smoothly rather than snapping (Josh, 2026-10-16). <details>
     cannot animate its own height, so the answer's height is animated and the element's open
     state is set around it - the markup stays a real <details> that works without script. */
  function questions() {
    document.querySelectorAll('.tt-contact__q').forEach(function (d) {
      var summary = d.querySelector('summary');
      var body = d.querySelector('.tt-contact__q-answer');
      if (!summary || !body || reduce || !body.animate) return;
      var running = null;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (running) running.cancel();
        var opening = !d.open;
        if (opening) d.open = true;
        var full = body.scrollHeight;
        running = body.animate(
          opening
            ? [{ height: '0px', opacity: 0 }, { height: full + 'px', opacity: 1 }]
            : [{ height: full + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 320, easing: 'cubic-bezier(0.32, 0.72, 0, 1)' }
        );
        body.style.overflow = 'hidden';
        running.onfinish = function () {
          running = null;
          body.style.overflow = '';
          if (!opening) d.open = false;
        };
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-tt-contact]').forEach(init);
    glide();
    questions();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
